import type {LngLat} from '@yandex-delivery/blocks'
import {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {useStatusContext} from '../../contexts/StatusContext'
import {FieldName, routeDestinationPrefixName} from '../../lib/fieldNames'

export const defaultCoordinates: LngLat = [0, 0]

/**
 * Хук, который создаёт функцию, вызываемую при триггере экшна add_destination.
 */
export const useAddDestinationAction = () => {
  const {control} = useFormContext()
  const {
    field: {onChange, value},
  } = useController({name: FieldName.Route, control})
  const {isFetching} = useStatusContext()

  return useCallback(() => {
    if (isFetching) {
      return
    }
    // Номер следующей точки: destination_${count}
    const addressNextCount = Object.keys(value).length

    onChange({
      ...value,
      [`${routeDestinationPrefixName}${addressNextCount}`]: {
        address: {
          coordinates: defaultCoordinates,
        },
      },
    })
  }, [onChange, value, isFetching])
}
